import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScoreByHod from "./ScoreByHod";
import {fetchSelfScorecardByHod} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    getUserScoreByHod: state.baMeetingReducer.getUserScoreByHod
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchSelfScorecardByHod,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ScoreByHod);
